import axios from "axios";
import { getAuth } from "firebase/auth";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

async function authHeaders() {
  const currentUser = getAuth().currentUser;
  const headers = { "Content-Type": "application/json" };
  if (currentUser) {
    headers.Authorization = `Bearer ${await currentUser.getIdToken()}`;
  }
  return headers;
}

/**
 * Ask the backend to HEAD-check a URL and return a normalised health result.
 *
 * @param {string} url - The URL to verify.
 * @returns {Promise<{ok: boolean, status_code: number|null, reason: string, safe_to_open: boolean}>}
 */
export async function verifyUrl(url) {
  try {
    const resp = await axios.post(
      `${API_BASE_URL}/api/utils/verify-url/`,
      { url },
      { headers: await authHeaders(), timeout: 12000 },
    );
    return resp.data;
  } catch (err) {
    if (err.response?.data) return err.response.data;
    return { ok: false, status_code: null, reason: "network_error", safe_to_open: false };
  }
}

/**
 * Submit a structured issue report to support@civixthread.com via the backend.
 *
 * @param {{
 *   issueType: string,
 *   url: string,
 *   source: string,
 *   description?: string,
 *   notes?: string,
 *   contextData?: object,
 * }} payload
 * @returns {Promise<{success: boolean, message?: string, error?: string}>}
 */
export async function reportIssue(payload) {
  const body = {
    issue_type: payload.issueType,
    url: payload.url,
    source: payload.source,
    description: payload.description || "",
    notes: payload.notes || "",
    context_data: payload.contextData || null,
  };
  const resp = await axios.post(
    `${API_BASE_URL}/api/utils/report-issue/`,
    body,
    { headers: await authHeaders(), timeout: 15000 },
  );
  return resp.data;
}
